import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CommonMethods } from 'src/app/services/common.method';
import { CommonService } from './common.service';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class StatesService {
  private _statesBehaviour: BehaviorSubject<any[]> = new BehaviorSubject([]);
  private _subStatesBehaviour: BehaviorSubject<any[]> = new BehaviorSubject([]);
  public states: Observable<any[]> = this._statesBehaviour.asObservable();
  public subStates: Observable<any[]> = this._subStatesBehaviour.asObservable();

  private _lookupresponseCache: BehaviorSubject<any[]> = new BehaviorSubject([]);
  public lookupresponseCache: Observable<any[]> = this._lookupresponseCache.asObservable();

  constructor(private commonMethods: CommonMethods, private httpCommon: CommonService, private auth: AuthService) { }

  public setStates(states: any[]) {
    this._statesBehaviour.next(states);
  }
  public setSubStates(subStates: any[]) {
    this._subStatesBehaviour.next(subStates);
  }


  public setLookUpData(lookUpRespCache: any[]) {
    this.commonMethods.LookUpData = lookUpRespCache;
    this._lookupresponseCache.next(lookUpRespCache);
  }
    /**
   * Delete data of tab related to advance filter
   */
  public deleteAdvanceFilterData(tabCounter: number) {
    let lookupDataIndex = this.commonMethods.LookUpData.findIndex(x => x.tabCounter == tabCounter);
    if (lookupDataIndex > -1) {
      this.commonMethods.LookUpData.splice(lookupDataIndex, 1);
    }
  }
   /**
   * Get lookup data for particular tab and store it in common data till tab closes, No observable created for it, because data remains till tab life
   */
  public GetLookupData(param: string, tabCounter: number): Observable<any> {
    let lookupdataCache = this.commonMethods.LookUpData.find(x => x.tabCounter == tabCounter);
    if (CommonMethods.CheckNullOrUndefined(lookupdataCache)) {
      return this.httpCommon.GetIntialData(this.auth.getCompanyId(), param).map(response => {
        let lookupObjectWithTabCounter: { tabCounter: number, lookupdata: any } = { tabCounter: -999, lookupdata: {} }; // -999 is no tabCounter in real scenerio
        lookupObjectWithTabCounter.tabCounter = tabCounter;
        lookupObjectWithTabCounter.lookupdata[param] = response[param];
        this.commonMethods.LookUpData.push(lookupObjectWithTabCounter);
        return response[param];
      }, error => {
        return of(null);
      }).catch((response: any) => {
        return of(null);
      });
    }
    else {
      if (CommonMethods.CheckNullOrUndefined(lookupdataCache.lookupdata[param])) {
        return this.httpCommon.GetIntialData(this.auth.getCompanyId(), param).map(response => {
          this.commonMethods.LookUpData.find(x => x.tabCounter == tabCounter).lookupdata[param] = response[param];
          return response[param];
        }, error => {
          return of(null);
        }).catch((response: any) => {
          return of(null);
        });
      }
      else {
        return of(lookupdataCache.lookupdata[param]);
      }
    }
  }
}
